import { useEffect, useState } from "react"
import { Alert, Form, Input } from "antd"
import { Link } from "react-router-dom"
import { AxiosError } from "axios"
import { useAuth } from "../../components/context/AuthContext"
import { resetSessionExpired } from "../../auth/AuthenticatedAxios"
import AuthPageLayout, { PrimaryButton } from "./AuthPageLayout"

type TLoginForm = {
    email: string
    password: string
}

const loginErrorText = (error: unknown) => {
    const response = (error as AxiosError<{ displayMessage?: string }>)?.response
    if (response?.data?.displayMessage) return response.data.displayMessage
    if (response?.status === 400 || response?.status === 401) return "E-Mail oder Passwort falsch"
    return "Anmeldung derzeit nicht möglich. Bitte versuchen Sie es später erneut."
}

export default function Login() {
    const auth = useAuth()
    const [submitting, setSubmitting] = useState(false)
    const [errorText, setErrorText] = useState<string | undefined>(undefined)

    // nach einem Sitzungsablauf unterdrückt messageError alle Toasts; auf der Login-Seite beginnt ein neuer Anlauf
    useEffect(() => {
        resetSessionExpired()
    }, [])

    const onFinish = async (values: TLoginForm) => {
        setSubmitting(true)
        setErrorText(undefined)
        try {
            // nach Erfolg leitet App.tsx über ?redirect= auf die angefragte Seite weiter
            await auth.login(values.email.trim(), values.password)
        } catch (error) {
            setErrorText(loginErrorText(error))
            setSubmitting(false)
        }
    }

    return (
        <AuthPageLayout title="Anmelden">
            {errorText && <Alert type="error" showIcon message={errorText} />}
            <Form<TLoginForm> layout="vertical" requiredMark={false} onFinish={onFinish} disabled={submitting}>
                <Form.Item
                    label="E-Mail"
                    name="email"
                    rules={[
                        { required: true, message: "Bitte E-Mail-Adresse eingeben" },
                        { type: "email", message: "Bitte eine gültige E-Mail-Adresse eingeben" },
                    ]}>
                    <Input autoComplete="username" autoFocus size="large" />
                </Form.Item>
                <Form.Item label="Passwort" name="password" rules={[{ required: true, message: "Bitte Passwort eingeben" }]}>
                    <Input.Password autoComplete="current-password" size="large" />
                </Form.Item>
                <PrimaryButton type="submit" disabled={submitting} loading={submitting}>
                    Anmelden
                </PrimaryButton>
            </Form>
            <div className="text-center">
                <Link to="/passwort/vergessen" className="text-primary hover:underline">
                    Passwort vergessen?
                </Link>
            </div>
        </AuthPageLayout>
    )
}
